import { getVersions } from '@shared/helpers/getVersions';
import { MajorTranslationVersion } from '@shared/content/types';

export const checkConsentVersionCookieValue = (
  cookie: string,
  dataFromPopUpContent: string | undefined,
): number | undefined => {
  // eslint-disable-next-line init-declarations
  let consentVersion;
  if (cookie === '' || cookie === 'null' || cookie === 'undefined') {
    if (typeof dataFromPopUpContent !== 'string') {
      return;
    } else if (dataFromPopUpContent) {
      consentVersion = getVersions(dataFromPopUpContent).majorVersion;
    }
  } else {
    // check if the number of the cookie belongs to the translation version we currently have
    if (!MajorTranslationVersion.includes(Number(cookie))) {
      return;
    }
    consentVersion = Number(cookie);
  }
  return consentVersion ?? undefined;
};
